import { Box, Link, useTheme } from "@mui/material";
import ProductLayer from "./ProductLayer";
import { useEffect, useState } from "react";
import { SectionHeader } from "@graphcommerce/next-ui";
import { useRouter } from "next/router";

export default function ProductRow(props) {
  const { products, items, setItems } = props;
  const theme = useTheme();

  const [layerMax, setLayerMax] = useState(0);

  const sortedItems = items.sort((a, b) => a.layer - b.layer);
  const router = useRouter();
  const routeSku = router?.query?.p === 'composite-poker-chips' || router?.query?.p === 'clay-poker-chips' ? router.query.p : undefined;
  const quantity = router?.query?.q ? router?.query?.q : products?.[0]?.price_tiers?.[0]?.quantity;

  useEffect(() => {
    const obj = products.find((o) => routeSku ? o.sku === routeSku : (o.sku === products?.[0]?.sku ?? 'composite-poker-chips'));
    setItems([...items, { layer: layerMax, quantity: quantity, obj: { ...obj } }]);
    setLayerMax((prev) => prev + 1);
  }, []);

  return (
    <>
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto',
        flexWrap: 'wrap',
        maxWidth: '100%'
      }}>
        <SectionHeader
          labelLeft={"Select custom product:"}
        />
        {sortedItems.map((item) => (
          <ProductLayer
            products={products}
            items={items}
            setItems={setItems}
            layer={item?.layer}
            key={item?.layer}
            item={item?.obj}
            initialQty={item?.quantity}
          />
        ))}
        <Box>
          <Link href={'/'} onClick={(e) => {
            e.preventDefault();
            const obj = products.find((o) => o.sku === products?.[0]?.sku ?? 'composite-poker-chips');
            setItems([...items, { layer: layerMax, quantity: products?.[0]?.price_tiers?.[0]?.quantity, obj: { ...obj } }]);
            setLayerMax((prev) => prev + 1);
          }}
            sx={{
              color: theme.palette.primary.main,
              textDecoration: 'none',
            }}>
            + Add another custom product
          </Link>
        </Box>
      </Box>
    </>
  );
}